import { gql } from '@apollo/client';

// Kept in a fragment-only module (no component/heavy-lib imports) so that
// registering it in the global fragment registry (fetching/graphql/fragments.ts)
// does not drag BookConfirmed.tsx — and its chart.js dependency — into the
// boot-time entry chunk. See Linear FE-831.
export const VisitAvailabilityFragment = gql`
    fragment VisitAvailabilityFragment on Availability {
        potentialAppointmentAssignments {
            clinician {
                id
                firstName
                lastName
            }
            clinicianAppointmentId
        }
        timeOptions {
            start
            end
        }
        timezone
    }
`;
